import React from 'react';
import { EventStateProvider } from '@apps/acquisitionFunnels/createWedding/EventState';
import { AllowedDesignParamsProvider } from '@apps/acquisitionFunnels/createWedding/components/AllowedDesignParamsProvider';
import { WebsiteV2OnboardingProvider } from '@apps/acquisitionFunnels/createWedding/components/WebsiteV2Onboarding/WebsiteV2OnboardingContext';

type FormFlowProvidersProps = Readonly<{
  children: React.ReactNode;
}>;

export const FormFlowProviders: React.FC<FormFlowProvidersProps> = ({ children }) => {
  return (
    <EventStateProvider>
      <WebsiteV2OnboardingProvider>
        <AllowedDesignParamsProvider>{children}</AllowedDesignParamsProvider>
      </WebsiteV2OnboardingProvider>
    </EventStateProvider>
  );
};
